export default "__VITE_ASSET__B7wUM8fE__"